export default __webpack_public_path__ + "static/media/google_play_badge_trimmed_564x168.0b981f51.png";